
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import CommonInfoDialog from "../dialogs/common-info-dialog.vue";
import orderAlert from "../reciever/order-alert.vue";
import RecieverSocket from "../reciever/reciever-socket.vue";
import AudioAlert from "./audio-alert.vue";
import commonToast from "./common-toast.vue";
// import FreshWorkWidget from './fresh-work-widget.vue';
import MakePayment from "./make-payment.vue";
import PushNotification from "./push-notification.vue";
import PwaUpdate from "./pwa-update.vue";
import QzPrintV2 from "./qz-print-v2.vue";
import QzPrint from "./qz-print.vue";
export default {
  components: {
    commonToast,
    CommonInfoDialog,
    RecieverSocket,
    PushNotification,
    AudioAlert,
    orderAlert,
    QzPrint,
    MakePayment,
    QzPrintV2,
    // FreshWorkWidget,
    PwaUpdate
  },
  data() {
    return {
      storeAvailabilityTimer: null
    };
  },
  computed: {
    ...mapGetters("auth", ["userInfoLoading"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapState("reciever", ["orderDetails"]),
    ...mapState("auth", ["user"])
  },
  created() {
    this.initStoreWatchers();
    this.registerServiceWorker();
    this.$nuxt.$on("switch-restaurant", this.clearSubsciptionData);
    this.$nuxt.$on(
      "check-auto-store-availability",
      this.initCheckAutoAtoreAvailability
    );
  },
  async mounted() {
    if (this.isAndroid()) {
      window.registerDevice = this.handleRegisterDevice;
    }
  },
  methods: {
    ...mapActions("reciever", ["getOrders"]),
    ...mapActions("auth", ["registerDevice"]),
    ...mapActions("restaurant", ["getLocationDetails"]),
    ...mapMutations("restaurant", ["SET_SUBSCRIPTION"]),
    initStoreWatchers() {
      // this.$store.watch(
      //   function(state) {
      //     return state.auth.user;
      //   },
      //   function(user) {
      //     if (user && user.restaurants && user.restaurants.length > 0) {
      //       this.$nuxt.$store.dispatch("restaurant/getLocationDetails");
      //     }
      //   },
      //   {
      //     deep: true
      //   }
      // );
    },
    registerServiceWorker() {
      if ("serviceWorker" in navigator) {
        window.addEventListener("load", function () {
          navigator.serviceWorker
            .register("/sw.js")
            .then(
              (registration) => {
                // Registration was successful
                // console.log(
                //   "ServiceWorker registration successful with scope: ",
                //   registration.scope
                // );
              },
              function (err) {
                // registration failed :(
                // console.log("ServiceWorker registration failed: ", err);
              }
            )
            .catch((err) => {
              console.log(err);
            });
        });
      }
    },

    clearSubsciptionData() {
      this.SET_SUBSCRIPTION({});
    },

    async handleRegisterDevice(paramsString = "") {
      try {
        // TODO::: Use the below code when the android app is updated for JSON
        // const { firebase_user_id, device_id, fcm_token } =
        //   JSON.parse(paramsString);
        const [firebase_user_id, device_id, fcm_token] = paramsString
          ?.trim()
          ?.split("|");
        $nuxt.$ls.set("firebase_user_id", firebase_user_id);
        $nuxt.$ls.set("device_id", device_id);
        $nuxt.$ls.set("fcm_token", fcm_token);
        await this.registerDevice({
          firebase_user_id,
          device_id,
          fcm_token
        });
        if (this.isAndroid()) {
          Android.isReadyToSendToken();
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
        console.log(error);
      }
    },

    initCheckAutoAtoreAvailability() {
      if (this.storeAvailabilityTimer) return;
      const bufferTime = 60000,
        checkIntervalMinutes = 30,
        $this = this;
      const checkInterval = checkIntervalMinutes * 60000;
      const firstExecution =
        (checkIntervalMinutes -
          (new Date().getMinutes() % checkIntervalMinutes)) *
          60000 +
        bufferTime;
      $this.storeAvailabilityTimer = setTimeout(() => {
        $this.getLocationDetails(false);
        $this.storeAvailabilityTimer = setInterval(() => {
          $this.getLocationDetails(false);
        }, checkInterval);
      }, firstExecution);
    }
  },
  beforeDestroy() {
    clearInterval(this.storeAvailabilityTimer);
    clearTimeout(this.storeAvailabilityTimer);
    this.$nuxt.$off("switch-restaurant");
    this.$nuxt.$off("check-auto-store-availability");
  }
};
